import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getWhatIsMyBusiness } from '../../../Redux/Actions/UserAction';
import { useTranslation } from 'react-i18next';

const SpDashboard = () => {
  const { t } = useTranslation();
  // const home = useSelector((state) => state.home);
  // const getMybusiness = home?.getMybusiness;

  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(getWhatIsMyBusiness());
  // }, [dispatch]);

  // useEffect(() => {
  //   if (getMybusiness && Object.keys(getMybusiness).length > 0) {
  //     sessionStorage.setItem(
  //       'paymentPlan',
  //       getMybusiness?.plan_info !== null &&
  //         getMybusiness?.plan_info !== undefined
  //         ? true
  //         : false
  //     );
  //     sessionStorage.setItem('BusinessId', getMybusiness?.businessId);
  //   }
  // }, [getMybusiness]);
  // console.log('getMybusiness', getMybusiness?.plan_info, getMybusiness);

  return (
    <div class="main-content-area">
      <div class="container">
        <h2 class="mb-3 text-center">{t('Register as Service Provider')}</h2>
        <h5 class="mb-5 text-center">
          {t('Who are you and what you offer to customer?')}
        </h5>

        <div class="row justify-content-center">
          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-garages-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/garage.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Garages')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-spare-parts-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/spare-parts.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Spare Parts')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-car-dealers-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/car-dealer.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Car Dealers')}</div>
              </Link>
            </div>
          </div>

          {/* [CF 2026-08-17] "Cars for Sale" removed from this grid. Client:
              it is not a business category. Every other tile here registers a
              company and starts a subscription; posting one car is something
              any ordinary user does from their own account. The route is
              untouched and still reachable from the menu, the footer and My
              Posts. */}

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-rent-car-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/rent-a-car.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Rent a Car')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-taxi-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/taxi.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Taxi')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-car-wash-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/car-wash.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Car Wash')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-car-towing">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/car-towing.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Car Towing')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-car-insurance-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/car-insurance.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Car Insurance')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-driving-school-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/driving-school.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Driving School')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-car-protection-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/car-protection.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Car Protection')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-air-conditioning-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/air-conditioning.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Air Conditioning')}</div>
              </Link>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
            <div class="icons-dashboard hvr-float">
              <Link to="/sp-quick-services-business">
                <div class="line-a">
                  <img
                    src="assets/images/service-icons/quick-services.svg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="line-b">{t('Quick Services')}</div>
              </Link>
            </div>
          </div>

          {/* <div class='col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5'>
						<div class='icons-dashboard hvr-float'>
							<Link to='/sp-cars-agents-business'>
								<div class='line-a'>
									<img
										src='assets/images/service-icons/cars-agents.svg'
										alt=''
										class='img-fluid'
									/>
								</div>
								<div class='line-b'>Cars Agents</div>
							</Link>
						</div>
					</div> */}
        </div>
      </div>
    </div>
  );
};

export default SpDashboard;
